import React from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery, UseQueryOptions } from 'react-query'
import { groupBy, indexBy, path, pathOr, prop } from 'ramda'
import { IActTypeGHG } from './options.type'

export const useActTypesByGHG = (
  query?: { name: number } & any,
  options?: UseQueryOptions<IActTypeGHG[]>
) => {
  const { t } = useTranslation()
  const { data, isLoading, refetch } = useQuery<IActTypeGHG[]>(
    ['/options/ghgProtocalVsActTypes', { ...query }],
    {
      select: data => pathOr([], ['data'], data),
      staleTime: Infinity, // 永遠新鮮，不會自動被視為過期
      cacheTime: Infinity, // 永遠不被回收
      refetchOnMount: false,
    }
  )
  const byMainTypeId = React.useMemo(() => {
    const obj = (data && groupBy(path(['mainType']) as any, data)) || {}
    return obj
  }, [data])

  const mainOptions = React.useMemo(
    () =>
      Object.keys(byMainTypeId).map(k => ({
        value: Number(k),
        label: t(`menu:ACT_SCOPE${k}`),
      })),
    [byMainTypeId]
  )

  const secondOptions = React.useMemo(() => {
    let secondOptions: any = {}
    Object.keys(byMainTypeId).map(k => {
      const mTypeObj = byMainTypeId[k]
      secondOptions[k] = mTypeObj.map(x => ({
        label: x.name,
        // ghgVsActType
        value: x.value,
      }))
    })
    return secondOptions
  }, [byMainTypeId])

  const byId = React.useMemo(() => indexBy(prop('value'), data || []), [data])

  return {
    data,
    isLoading,
    refetch,
    mainOptions,
    secondOptions,
    byMainTypeId,
    byId,
  }
}
